// GraphQL fragments for authentication-related queries

export const USER_FRAGMENT = `
  id
  name
  phone
  email
  isLocked
`;

// Extended user fragment with additional fields if needed
export const USER_DETAILS_FRAGMENT = `
  ${USER_FRAGMENT}
`;

// Login response fragment
export const LOGIN_RESPONSE_FRAGMENT = `
  token
  user {
    ${USER_FRAGMENT}
  }
`;

// Registration response fragment
export const REGISTRATION_RESPONSE_FRAGMENT = `
  message
  email
  otpExpiredAt
`;

// OTP verification response fragment
export const VERIFY_OTP_RESPONSE_FRAGMENT = `
  token
  user {
    ${USER_FRAGMENT}
  }
`;